import { useEffect, useRef } from 'react'

export const useRunOnce = (func: () => void) => {
    const hasRun = useRef(false)

    useEffect(() => {
        if (!hasRun.current) {
            func()
            hasRun.current = true
        }
    })
}
